import { OUTSIDE_API } from '../../../consts/endpoints';
import { postData } from '../../../utils/http';
import showSnackbar from '../../../utils/showSnackbar';
import RESPONSE_CODES from '../../../consts/responseCodes';
import {
  doesArrayHasLength,
  isArray,
  isUndefined
} from '../../../utils/isDefined';
import { translate } from '../../../i18n/I18nProvider';

const sendActivationMessage = async ({
  clientDomain,
  usersConnectIds,
  data
}) => {
  if (isUndefined(clientDomain)) {
    showSnackbar({
      intlTextKey: 'MESSAGE.NO_DOMAIN',
      messageType: 'error'
    });

    return { isActionCompleted: false };
  }
  const mappedData = mapData({ usersConnectIds, data });

  try {
    const response = await postData({
      url: `${OUTSIDE_API.CLIENTS}/${clientDomain}/activation_message`,
      data: mappedData
    });

    const { data, status } = response;

    if (status === RESPONSE_CODES.CREATED) {
      if (isUndefined(data)) {
        showSnackbar({
          intlTextKey: 'MESSAGE.ACTIVATION_MESSAGE_SEND',
          messageType: 'success'
        });

        return { isActionCompleted: true };
      }

      if (
        data.failedUsers === 0 &&
        data.succeededUsers > 0 &&
        usersConnectIds.length === 1
      ) {
        showSnackbar({
          intlTextKey: 'MESSAGE.ACTIVATION_MESSAGE_SEND',
          messageType: 'success'
        });

        const results = isArray(data.activationResultDTOs)
          ? mapResults(data.activationResultDTOs)
          : undefined;

        return { isActionCompleted: true, results };
      } else {
        if (isArray(data.activationResultDTOs)) {
          const results = mapResults(data.activationResultDTOs);

          const failedResults = data.activationResultDTOs.filter(
            dto => dto.isFailure
          );

          if (failedResults.some(dto => !dto.isHavingFailureReasons)) {
            return {
              isActionCompleted: false,
              results,
              responseErrors: [
                translate('MESSAGE.NO_REASON'),
                translate('MESSAGE.CONTACT_SUPPORT')
              ]
            };
          }

          const responseErrors = results.reduce((arr, res) => {
            if (res.isSuccess) {
              return arr;
            }

            return [
              ...arr,
              ...res.errors.map(error => `${res.username}: ${error}`)
            ];
          }, []);

          return { isActionCompleted: false, responseErrors, results };
        }

        showSnackbar({
          intlTextKey: 'MESSAGE.CONTACT_SUPPORT',
          messageType: 'error'
        });

        return { isActionCompleted: false };
      }
    }

    return { isActionCompleted: false };
  } catch {
    return { isActionCompleted: false };
  }
};

export default sendActivationMessage;

const mapData = ({ usersConnectIds, data }) => {
  return {
    userId: usersConnectIds,
    ...data
  };
};

const mapResults = activationResultDTOs => {
  return activationResultDTOs.map(res => ({
    userId: res.userId,
    username: res.userId?.split('@')[0],
    isSuccess: res.isSuccess,
    devices: isArray(res.devices)
      ? res.devices.map(device => ({
          deviceType: device.deviceType,
          isSuccess: device.isSuccess,
          reasons: device.failureReasons
        }))
      : [],
    errors: isArray(res.devices)
      ? res.devices.reduce((arr, device) => {
          if (doesArrayHasLength(device.failureReasons)) {
            return [
              ...arr,
              ...device.failureReasons.map(
                reason => `${device.deviceType}: ${reason}`
              )
            ];
          }

          return arr;
        }, [])
      : []
  }));
};
